import script from "./PickStock.vue?vue&type=script&setup=true&lang=js"
export * from "./PickStock.vue?vue&type=script&setup=true&lang=js"

import "./PickStock.vue?vue&type=style&index=0&id=019a153a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-019a153a"]])

export default __exports__